import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "diagonal-lemon grid items-center rounded-l-lg px-2.5" }
const _hoisted_2 = { class: "py-4 pr-10" }
const _hoisted_3 = { class: "ocm-headline3 mb-1" }
const _hoisted_4 = ["href"]

import { ref, watch, onMounted, onBeforeUnmount } from "vue";
import SvgIcon from "@SharedVueComponents/SvgIcon/SvgIcon.vue";
import CloseButton from "@SharedVueComponents/CloseButton/CloseButton.vue";
import OcmMessenger from "ocm_mercurius_messenger";
import { messengerPublicationTypes } from "@ocm/services/services.constants";
import { GlobalRouterMessengerData } from "@/shared/types/messenger.type";
import { shopContextPath } from "@ocm/services/ocm-object";
import { formatPrice } from "@ocm/services/services.numberFormatter";
import pushDataLayer from "@ocm/services/dataLayer";

type EmarsysConfig = {
	cartMinValue?: number;
};
const CART_MIN_VALUE_DEFAULT = 100;
const TOAST_DELAY = 5 * 1000;


export default /*@__PURE__*/_defineComponent({
  __name: 'EmarsysToast',
  setup(__props) {

const cartUrl = ref(`${shopContextPath}/cart/`);
const _isCart = () => window.location.pathname.includes("/cart/");
const _isPDP = () => {
	const lastSlash = window.location.pathname.lastIndexOf("/");
	const maybeProductCode = window.location.pathname.substring(lastSlash - 9, lastSlash);
	return maybeProductCode.length && !Number.isNaN(+maybeProductCode);
};

// Tracking
const trackGA3Toast = (action: string) => {
	const pagePath = window.recommendationData?.Recommendation?.pageData?.pagePath ?? "";
	pushDataLayer({
		event: "GAevent",
		event_category: "S_jetztSparenLayer",
		event_action: action,
		event_label: pagePath,
	});
};

const routeToCart = () => {
	if (_isCart()) return;
	trackGA3Toast("S_cart");
	window.ocmOrchestrator ? window.ocmOrchestrator.spaNavigateUrl(cartUrl.value) : window.location.assign(cartUrl.value);
};

const hasToast = ref(false);
const removeToast = () => {
	hasToast.value = false;
};
const isToastVisible = ref(true);
const _setIsToastVisible = (val: boolean) => {
	isToastVisible.value = val;
};
const savingTotal = ref("");
watch(savingTotal, (val) => {
	if (!val) removeToast();
});

let _delayTimeout: number;
const _setupToast = (cartMinValue = CART_MIN_VALUE_DEFAULT) => {
	if (sessionStorage.getItem("cartToastShown")) return;

	clearTimeout(_delayTimeout);
	_delayTimeout = setTimeout(() => {
		const cartData = window.recommendationData?.Recommendation?.customerData?.cart;
		// abbrechen, wenn der Warenkorb leer ist oder sein Gesamtwert einen definierten Mindestwert unterschreitet
		if (!cartData?.products?.length || +cartData.cartTotal < cartMinValue) return;

		if (!savingTotal.value) {
			const saving = cartData.products.reduce(
				(acc, { msrp, price, quantity }) => acc + (+msrp - +price) * +quantity,
				0
			);
			savingTotal.value = formatPrice(saving, cartData.currency);
		}

		if (_isCart() || _isPDP()) _setIsToastVisible(false);
		hasToast.value = true;
		trackGA3Toast("S_show");
		try {
			sessionStorage.setItem("cartToastShown", "1");
		} catch (error) {
			console.error(error);
		}
	}, TOAST_DELAY);
};

onMounted(() => {
	OcmMessenger.subscribe(messengerPublicationTypes.UPDATED_CART_SAVING, ({ data }: { data: string }) => {
		savingTotal.value = data;
	});
	OcmMessenger.subscribe(messengerPublicationTypes.ADD_EMARSYS_TOAST, ({ data }: { data?: EmarsysConfig }) => {
		_setupToast(data?.cartMinValue);
	});
	OcmMessenger.subscribe(
		messengerPublicationTypes.ROUTE_CHANGE_MOUNTED_APPS,
		({ data: { mountedApps } }: GlobalRouterMessengerData) => {
			_setIsToastVisible(!mountedApps.includes("mf-cart") && !_isPDP());
		}
	);
	OcmMessenger.subscribe(messengerPublicationTypes.ENTER_PRODUCTDETAIL, () => {
		_setIsToastVisible(false);
	});
	OcmMessenger.subscribe(messengerPublicationTypes.LEAVE_PRODUCTDETAIL, () => {
		_setIsToastVisible(true);
	});
});

onBeforeUnmount(() => {
	clearTimeout(_delayTimeout);
	removeToast();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "#emarsys-toast-container" }, [
    _createVNode(_Transition, { name: "emarsys-toast" }, {
      default: _withCtx(() => [
        (hasToast.value && isToastVisible.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "emarsys-toast ocm-body1 pointer-events-auto relative mb-2 grid min-h-5 max-w-96 grid-cols-[4.8571428571rem,1fr] justify-self-center rounded-lg bg-gray-beton focus:outline focus:outline-2 focus:outline-offset-2 focus:outline-current",
              tabindex: "-1",
              onClick: _cache[2] || (_cache[2] = ($event: any) => {
					removeToast();
					routeToCart();
				})
            }, [
              _createVNode(CloseButton, {
                class: "close-button right-0 top-1 border-transparent",
                inverted: "",
                "aria-label": "Nachricht schließen",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => {
						removeToast();
						trackGA3Toast('S_closeX');
					}, ["stop"]))
              }),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(SvgIcon, {
                  class: "h-7 w-7",
                  "icon-name": "circle-percent"
                })
              ]),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, "Sie sparen " + _toDisplayString(savingTotal.value), 1),
                _createElementVNode("div", null, [
                  _cache[3] || (_cache[3] = _createTextVNode(" Auf die Artikel ")),
                  _createElementVNode("a", {
                    href: cartUrl.value,
                    class: "inline-block underline after:inline-block after:whitespace-pre after:content-['_'] last:after:content-none hover:text-gray-90",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
                  }, " in Ihrem Warenkorb ", 8, _hoisted_4)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})